module.exports = __webpack_public_path__ + "static/media/arrow-right.29968100.svg";